import { madSDK } from "../../sdk";
/**
 * Hook to access the madSDK instance.
 * This provides a convenient way to access the madSdk instance used within mad-hooks.
 */
export function useMadSdk() {
    return madSDK;
}
//# sourceMappingURL=useMadSdk.js.map